import { Vue, Component } from 'vue-property-decorator';
import { Route } from 'vue-router';

Component.registerHooks(['beforeRouteLeave']);
@Component
export default class PageLeaveGuardVue extends Vue {
  protected acceptLeave = true;
  /**
   * @customValidation
   * acceptLeave 외에 무언가 검증 수단이 더 필요할때 이 녀석을 상속받은 클래스에서 재 정의하세요.
   * ex) this.customValidation = coffee => {
   *   return coffee.temperature >= 70
   * }
   */
  protected customValidation = (): boolean => {
    return true
  }

  get accept(): boolean {
    return this.acceptLeave && this.customValidation()
  }

  mounted() {
    this.bindBeforeunloadEvent();
  }

  beforeDestroy() {
    this.removeBeforeunloadEvent();
  }

  beforeRouteLeave(to: Route, from: Route, next: () => void): void {
    if (!this.accept) {
      const answer = confirm(this.$t('CONFIRM_UNSAVED').toString());
      if (answer) {
        this.acceptLeave = true;
        next();
      }
    } else {
      next();
    }
  }

  private bindBeforeunloadEvent(): void {
    window.addEventListener('beforeunload', this.unloadGuard);
  }

  private removeBeforeunloadEvent(): void {
    window.removeEventListener('beforeunload', this.unloadGuard);
  }

  private unloadGuard(event) {
    if (this.accept) return;
    event.preventDefault();
    event.returnValue = ''; // Chrome Browser Polyfill
  }

  /**
   * @beforeEventCheckLeave
   * beforeunload, beforeRouteLeave 가 가드 해줄 수 없는데 가드가 필요한 경우가 때때로 발생합니다.
   * 그러한 케이스가 발생할때 해당 케이스에 이 메서드를 삽입하여 가드를 할 수 있습니다.
   * ex) if (!this.beforeEventCheckLeave()) return;
   */
  public beforeEventCheckLeave(): boolean {
    if (this.accept) return true;
    const answer = confirm(this.$t('CONFIRM_UNSAVED').toString());
    if (answer) {
      this.acceptLeave = true
      return true;
    } else {
      return false
    }
  }
}